module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "splash-box"
  }, [_c('div', {
    staticClass: "logo_box"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../assets/img/common/logo_loading.png")
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "gear_big"
  }), _vm._v(" "), _c('i', {
    staticClass: "gear_small"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-488b4384"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Loading.vue
// module id = 774
// module chunks = 1